var map = {
	"./bac.jpg": "Xk7Y",
	"./fish.png": "q5M+",
	"./pdf-export.png": "ol7p"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F0dO";


//////////////////
// WEBPACK FOOTER
// ./src/static/projectImg ^\.\/.*$
// module id = F0dO
// module chunks = 1